import { render, staticRenderFns } from "./WorkshopSetup.vue?vue&type=template&id=e45153c2&scoped=true"
import script from "./WorkshopSetup.vue?vue&type=script&lang=js"
export * from "./WorkshopSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45153c2",
  null
  
)

export default component.exports